import { useState, useRef, useEffect } from "react";
import infoCircle from "../assets/info-circle.svg";
import dots from "../assets/verticle-dots.svg";
import edit from "../assets/edit.svg";
import trash from "../assets/red-trash.svg";
import add from "../assets/plus-blue.svg";
import {
  deletePage,
  fetchLanguageList,
  fetchRegionList,
} from "../action/page";
import CommonModal from "./CommonModal";
import { useNavigate } from "react-router-dom";
import cross from "../assets/black-cross.svg";
import inputbadge from "../assets/pen1.svg";
import { useToast } from "./ToastProvider";
import { deleteBlog } from "../action/blogs";

const LanguageSpecific = ({ blogId, blogData, setBlogData }) => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const dropdownRef = useRef(null);
  const [loadingLists, setLoadingLists] = useState(false);

  const [showRegionModal, setShowRegionModal] = useState(false);
  const [languages, setLanguages] = useState([]);

  const [selectedLanguage, setSelectedLanguage] = useState("");

  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");

  // ------------------------------
  // FETCH LANGUAGE LIST
  // ------------------------------
  const loadLists = async () => {
    setLoadingLists(true);
     const r = await fetchRegionList();
        const l = await fetchLanguageList();
        setRegions(r?.data?.list || []);
        setLanguages(l?.data?.list || []);
    setLoadingLists(false);
  };

  // ------------------------------
  // DELETE VERSION
  // ------------------------------
  const handleDeletePageVersion = async (versionId) => {
    if (!window.confirm("Are you sure you want to delete this version?"))
      return;

    try {
      const res = await deleteBlog(versionId);

      if (res?.status) {
        showToast("Version deleted successfully", "success");

        setBlogData((prev) => ({
          ...prev,
          all_blogs: prev.all_blogs.filter((p) => p._id !== versionId),
        }));

        setOpenDropdownIndex(null);
      } else {
        showToast(res?.message || "Failed to delete version", "error");
      }
    } catch (err) {
      showToast("Delete failed", "error");
    }
  };

  // Get already added language names
  const addedLanguageNames =
    blogData?.all_blogs?.map((b) => b?.language?.name?.toLowerCase()) || [];

  // Filter languages that are NOT already added
  const remainingLanguages = languages.filter(
    (lang) => !addedLanguageNames.includes(lang.name?.toLowerCase())
  );

  // ------------------------------
  // CLOSE DROPDOWN ON OUTSIDE CLICK
  // ------------------------------
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdownIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!blogId) return null;

  return (
    <>
      <div className="theme-card p-4 mb-3">
        <div className="card-title pb-1 d_flex">Language Specific Content</div>

        <label className="frm-label d-flex align-items-center">
          Manage localized versions of this blog.
          <img className="ms-2" src={infoCircle} alt="Info" />
        </label>

        {/* LIST ALL LANGUAGE VERSIONS */}
        {blogData?.all_blogs?.map((l, index) => {
          const isEditingThisPage = blogId === l._id;

          return (
            <div
              key={index}
              className="coutry-fields"
              style={{ position: "relative" }}
            >
              <div className="input-with-icon right mt-3">
                {isEditingThisPage && (
                  <div className="input_badge">
                    <img src={inputbadge} alt="icon" />
                    <span className="field-label">Editing Blog</span>
                  </div>
                )}

                <input
                  type="text"
                  className="frm-input"
                  value={l.locale}
                  readOnly
                />

                <img
                  src={dots}
                  className="input-icon pointer"
                  alt="dots"
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdownIndex(
                      openDropdownIndex === index ? null : index
                    );
                  }}
                />
              </div>

              {/* DROPDOWN */}
              {!isEditingThisPage && openDropdownIndex === index && (
                <div className="region-dropdown-menu" ref={dropdownRef}>
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      navigate(`/blogs/${l._id}`);
                    }}
                  >
                    <img src={edit} alt="icon" /> Edit Blog Content
                  </div>

                  { !l?.is_parent ? (
                    <div
                      className="dropdown-item delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeletePageVersion(l._id);
                      }}
                    >
                      <img src={trash} alt="icon" /> Delete Blog Version
                    </div>
                  ): ""}
                </div>
              )}
            </div>
          );
        })}

        {/* ADD NEW LANGUAGE */}
        <div className="addmore pt-3">
          {/* {languages && remainingLanguages.length > 0 ? ( */}
            <button
              type="button"
              className="add-blue-link"
              onClick={() => {
                loadLists();
                setShowRegionModal(true);
              }}
            >
              <img alt="add" src={add} /> Add New Language
            </button>
          {/* ) : (
            <div className="text-success fw-semibold">
              Blogs added for all languages
            </div>
          )} */}
        </div>
      </div>

      {/* LANGUAGE MODAL */}
      {showRegionModal && (
        <CommonModal
          show={showRegionModal}
          onClose={() => setShowRegionModal(false)}
          width="500px"
          height="auto"
        >
          
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 20,
              fontWeight: 600,
            }}
          >
            Select Language
            <img
              src={cross}
              alt="icon"
              className="pointer"
              onClick={() => setShowRegionModal(false)}
            />
          </div>

            {/* Region */}
            <label className="frm-label">Select Region</label>
          <select
            className="frm-input"
            value={selectedRegion}
            disabled={loadingLists} 
            onChange={(e) => setSelectedRegion(e.target.value)}
          >
            {loadingLists ? (
              <option>Loading regions...</option>
            ) : (
              <>
                <option value="">Choose region</option>
                {regions.map((r) => (
                  <option key={r._id} value={r._id}>
                    {r.name}
                  </option>
                ))}
              </>
            )}
          </select>

          <label className="frm-label mt-3">Select Language</label>
          <select
            className="frm-input"
            value={selectedLanguage}
            disabled={loadingLists}
            onChange={(e) => setSelectedLanguage(e.target.value)}
          >
            <option value="">Choose language</option>
            {remainingLanguages.map((l) => (
              <option key={l._id} value={l._id}>
                {l.name}
              </option>
            ))}
          </select>

          <div className="modal-actions mt-4">
            <button
              className="btn-white"
              onClick={() => setShowRegionModal(false)}
            >
              Cancel
            </button>

            <button
              className="btn-black"
              onClick={() => {
                if (!selectedRegion || !selectedLanguage) return;

                const regionObj = regions.find((r) => r._id === selectedRegion);
                const langObj = languages.find((l) => l._id === selectedLanguage);

                if (!regionObj || !langObj) return;
                const locale = `${regionObj.code}-${langObj.slug}`;
                // Get parent id (original blog)
                const trueParentId = blogData?.parent_id || blogId;

                showToast("Language selected", "success");
                setShowRegionModal(false);

                // 🚀 JUST NAVIGATE — NO API CALL
                navigate(`/blogs/new/${trueParentId}?lang=${locale}`);
              }}
            >
              Confirm
            </button>
          </div>
        </CommonModal>
      )}
    </>
  );
};

export default LanguageSpecific;
